import { useMutation, useQuery } from "@tanstack/react-query";
import {
  createVerifyPayment,
  IdVerification,
  paymentVerifyCallback,
  paymentVerifyStatus,
  PhysicalVerification,
  requestNewPincodeApi,
  VerificationDetails,
  verifyPincode,
} from "api/accountverify";

export const useVerificationDetails = (options = {}) => {
  return useQuery({
    queryKey: ["verificationDetails"],
    queryFn: VerificationDetails,
    ...options,
  });
};

export const usePhysicalVerification = () => {
  return useMutation({
    mutationFn: PhysicalVerification,
  });
};

export const useIdVerification = () => {
  return useMutation({
    mutationFn: IdVerification,
  });
};

export const useCreateVerifyPayment = (options = {}) => {
  return useMutation({
    mutationFn: createVerifyPayment,
    onSuccess: (data, variables, context) => {
      options.onSuccess?.(data, variables, context);
    },
  });
};

export const usePaymentVerifyCallback = (txnid, options = {}) => {
  return useQuery({
    queryKey: ["physical_callback", txnid],
    queryFn: () => paymentVerifyCallback(txnid),
    enabled: !!txnid,
    ...options,
  });
};

export const usePaymentVerifyStatus = (options = {}) => {
  return useMutation({
    mutationFn: paymentVerifyStatus,
    onSuccess: (data, variables, context) => {
      options.onSuccess?.(data, variables, context);
    },
  });
};

export const useVerifyPincode = (options = {}) => {
  return useMutation({
    mutationFn: verifyPincode,
    onSuccess: (data, variables, context) => {
      options.onSuccess?.(data, variables, context);
    },
    onError: (error, variables, context) => {
      options.onError?.(error, variables, context);
    },
    onSettled: () => {
      options.onSettled?.();
    },
  });
};

export const useRequestNewPincode = (options = {}) => {
  return useMutation({
    mutationFn: requestNewPincodeApi,
    onSuccess: (data, variables, context) => {
      options.onSuccess?.(data, variables, context);
    },
    onError: (error, variables, context) => {
      options.onError?.(error, variables, context);
    },
  });
};

